import React, { useState } from 'react';

export const StoriesInfo: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <div className="my-4">
      <h6 className="fw-bold text-success cursor-pointer" onClick={toggleOpen}>
        <i className="bi bi-question-circle me-1"></i>
        Как отображаются истории у клиента?
      </h6>

      {isOpen && (
        <div className="text-gray-800">
          <div className="fw-bold">Порядок в ленте:</div>
          Непросмотренные истории идут первыми, потом просмотренные. Внутри
          групп сортировка по <strong>Приоритету</strong>: чем больше число, тем
          выше приоритет и раньше показывается. Если приоритет одинаковый, идёт
          сортировка по дате создания. Сначала старые истории, потом новые.
          Автозапуск показывает историю → она считается просмотренной и уходит в
          конец. При этом история считается просмотренной, если просмотрены все
          слайды.
          <div className="fw-bold">Автозапуск:</div>
          Автозапуск срабатывает один раз за заход. Выбирается только одна
          непросмотренная история с наибольшим <strong>Приоритетом</strong>.
          Если приоритет одинаковый — открывается история по дате создания
          (старые раньше). История, которая уже была показана автоматически,
          повторно не открывается автоматически.
          <div className="fw-bold">Тестирование:</div>Данные автозапуска
          сохраняются в кэш браузера. Для новых пользователей используйте режим
          инкогнито.
        </div>
      )}
    </div>
  );
};
